// Curated product changelog for the Dev Dashboard, backdated to early offline development.
// Sourced from .agent-log.md (sessions 1–40) and devlog/LOG.md. Newest first.
// This is hand-maintained reference content — add an entry at the top when shipping something notable.

export type ChangelogCategory = 'feature' | 'fix' | 'security' | 'infra' | 'ux';

export interface ChangelogEntry {
  date: string;            // ISO date
  title: string;
  category: ChangelogCategory;
  items: string[];
}

export const CHANGELOG: ChangelogEntry[] = [
  {
    date: '2026-06-24',
    title: 'Recovered roadmap + timesheet SMS repair + calendar sync',
    category: 'feature',
    items: [
      'Fixed employee timesheet SMS: the 5 PM one-time magic-link cron was dead (wrong sms import) — now sends correctly; live-verified delivery.',
      'Added worker assignment to the calendar event modal (previously only Jobs/Employees/Crews had it).',
      'Calendar sync: per-user .ics subscription URL with copy + Google/iCloud/Outlook instructions across admin, employee, and client portals.',
      'Portal preview now skips the login screen for portal pages and shows test credentials on the login screen itself.',
      'Wayland desktop-environment prototype wired in as a Dev Dashboard tab.',
      'Closed a portal data leak: client job list no longer exposes internal job budget.',
    ],
  },
  {
    date: '2026-06-22',
    title: 'AI Quote Wizard hardening + standalone estimate engine',
    category: 'feature',
    items: [
      'Quote Wizard: auto-creates a draft job so quotes are never orphaned; client + title persist.',
      'Quote Wizard: poll loops terminate on 404/expiry; Cancel button + elapsed timer; no more infinite spinner.',
      'Claude CLI calls given hard timeouts with stderr surfacing.',
      'Standalone 3-draw framing estimate engine (PDF plans in → priced estimate out).',
      'Architecture Map page: interactive recursive element trees for every feature.',
      'devlog/ continuity hub (status, log, runbook, known issues, decisions, backlog).',
    ],
  },
  {
    date: '2026-06-20',
    title: 'Security & quality audit',
    category: 'security',
    items: [
      'Added auth middleware to 6 unprotected routes (crews, quotes, schedule, vendors, subtasks, documents).',
      'Portal users can no longer log into the admin app; JWT secrets rotated off dev placeholders.',
      'Portal login rate-limited; invoice overdue sweep moved off every GET to a daily cron.',
      'Blocked payment overpayment and holdback-exceeds-total; change-order approval tokens now expire.',
      'Dev Dashboard Security Audit tab tracks all findings.',
    ],
  },
  {
    date: '2026-06-15',
    title: 'Portal, payroll, and data-integrity sprint',
    category: 'fix',
    items: [
      'Fixed JWT-protected document downloads across client, employee, and job document views.',
      'Jobs: 9 site/access/notes fields were silently discarded — now persisted end to end.',
      'Consolidated 20+ migration-only tables/columns into the canonical schema for fresh installs.',
      'Fixed a foreign-key bloat bug adding a duplicate constraint to materials on every restart.',
      'Work Agreement Builder (full-stack), quote→agreement workflow, and global search coverage.',
      'GPS time-clock for the employee portal with auto draft time entries.',
      'Currency formatting normalized across catalog, employees, invoices, and client views.',
    ],
  },
  {
    date: '2026-06-14',
    title: 'Autonomous Agent Fleet',
    category: 'infra',
    items: [
      'Agent fleet orchestrator: pulls open agent tasks and runs the Claude CLI in managed slots.',
      'Pre/post-task snapshots to .snapshots/ with optional Drive upload; nightly snapshot cron.',
      'Run history, intentions parsing, and live slot cards in the Dev Dashboard.',
    ],
  },
  {
    date: '2026-06-13',
    title: 'Claude AI integration',
    category: 'feature',
    items: [
      'Claude AI wired in via the Claude Code CLI (chat, job descriptions, material suggestions, draft messages, schedule suggestions).',
      'Floating AI assistant panel with a read-only DB query tool.',
    ],
  },
];
